import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';

// Hourly website traffic during the selected window — sessions (navy) and
// users (teal) on a shared count axis. Mirrors CesTrendChart's styling.
// `rows` come from /analytics/dashboard → hourly: [{label, sessions, users}].
export default function HourlyTrafficChart({ rows, loading }) {
  if (loading) {
    return <div className="chart-card__empty">Loading traffic…</div>;
  }
  if (!rows || rows.length === 0) {
    return <div className="chart-card__empty">No traffic in this window yet</div>;
  }

  return (
    <ResponsiveContainer width="100%" height={320}>
      <LineChart data={rows} margin={{ top: 8, right: 16, left: 0, bottom: 0 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="#EDF2F7" />
        <XAxis dataKey="label" tick={{ fontSize: 11 }} interval="preserveStartEnd" minTickGap={24} />
        <YAxis allowDecimals={false} tick={{ fontSize: 11 }} width={34} />
        <Tooltip
          contentStyle={{ fontSize: 12, borderRadius: 6, border: '1px solid #E2E8F0' }}
        />
        <Legend wrapperStyle={{ fontSize: 12 }} />
        <Line
          type="monotone"
          dataKey="sessions"
          name="Sessions"
          stroke="#00205C"
          strokeWidth={3}
          dot={false}
          isAnimationActive={false}
        />
        <Line
          type="monotone"
          dataKey="users"
          name="Users"
          stroke="#1FA9C3"
          strokeWidth={1.5}
          dot={false}
          isAnimationActive={false}
        />
      </LineChart>
    </ResponsiveContainer>
  );
}
